export default __webpack_public_path__ + "static/media/reload.a4b494dc.svg";